import { Type } from 'class-transformer';
/**
 * Model for dropdown name and corresponding array of values of ApplicationValue type.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class ApplicationType {
    id: number;
    name: string;
    @Type(() => ApplicationValue)
    values: ApplicationValue[];
}

/**
 * This signifies the value populated in the dropdown and its corresponding id.
 * As this class cannot stand alone, thereby making it a part of ApplicationType only.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class ApplicationValue {
    id: number;
    name: string;
}



// WEBPACK FOOTER //
// ./src/app/services/warmup/application-type.model.ts